import { lazy } from "react";
import Root from "@/pages/Root";
import ProtectedRoutes from "@/components/ProtectedRoutes";
import { ROUTES_PATH } from "./paths";

const Dashboard = lazy(() => import("@/pages/Dashboard"));
const ChatPage = lazy(() => import("@/pages/Chat"));
const AssetsPage = lazy(() => import("@/pages/AssetsPage"));
const PricingPage = lazy(() => import("@/pages/Pricing"));
const BillingPage = lazy(() => import("@/pages/Billing"));
const AccountLayout = lazy(() => import("@/pages/Account"));
const ProfilePage = lazy(() => import("@/pages/Profile"));

import Register from "@/pages/Register";
import Login from "@/pages/Login";
import ForgotPassword from "@/pages/ForgotPassword";
import UpdatePassword from "@/pages/UpdatePassword";
import NotFound from "@/pages/NotFound";

export default [
  {
    path: ROUTES_PATH.ROOT,
    element: <Root />,
    children: [
      {
        path: ROUTES_PATH.LOGIN,
        element: <Login />,
      },
      {
        path: ROUTES_PATH.REGISTER,
        element: <Register />,
      },
      {
        path: ROUTES_PATH.FORGOT_PASSWORD,
        element: <ForgotPassword />,
      },
      {
        path: ROUTES_PATH.DASHBOARD,
        element: (
          <ProtectedRoutes.Authenticated>
            <ProtectedRoutes.SubscriptionProtected>
              <Dashboard />
            </ProtectedRoutes.SubscriptionProtected>
          </ProtectedRoutes.Authenticated>
        ),
      },
      {
        path: `${ROUTES_PATH.CHAT}/:botId`,
        element: (
          <ProtectedRoutes.Authenticated>
            <ProtectedRoutes.SubscriptionProtected>
              <ChatPage />
            </ProtectedRoutes.SubscriptionProtected>
          </ProtectedRoutes.Authenticated>
        ),
      },
      {
        path: ROUTES_PATH.ASSETS,
        element: (
          <ProtectedRoutes.Authenticated>
            <AssetsPage />
          </ProtectedRoutes.Authenticated>
        ),
      },
      {
        path: ROUTES_PATH.PRICING,
        element: (
          <ProtectedRoutes.Authenticated>
            <PricingPage />
          </ProtectedRoutes.Authenticated>
        ),
      },
      {
        path: ROUTES_PATH.ACCOUNT,
        element: (
          <ProtectedRoutes.Authenticated>
            <AccountLayout />
          </ProtectedRoutes.Authenticated>
        ),
        children: [
          {
            path: ROUTES_PATH.PROFILE,
            element: <ProfilePage />,
          },
          {
            path: ROUTES_PATH.BILLING,
            element: <BillingPage />,
          },
        ],
      },
      {
        path: ROUTES_PATH.UPDATE_PASSWORD,
        element: (
          <ProtectedRoutes.PartialAuth>
            <UpdatePassword />
          </ProtectedRoutes.PartialAuth>
        ),
      },
    ],
  },
  {
    path: ROUTES_PATH.NOT_FOUND,
    element: <NotFound />,
  },
];
